import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    scope: String,
    name: String,
    value: String,
  };

  unfilter() {
    this.dispatch(`${this.scopeValue}:${this.nameValue}:unfilter`, {
      detail: { name: this.nameValue, value: this.valueValue },
      bubbles: true,
    });
  }
}
